import { Component, Input, OnInit } from '@angular/core';

import { ProgressBar } from '../../notes/progress-bar/progress-bar.model';
import { checkInputsForText } from '../../design-system.helper';

@Component({
  selector: 'progress-bar-grid',
  templateUrl: './progress-bar-grid.component.html',
  styleUrls: ['./progress-bar-grid.component.scss'],
})
export class ProgressBarGridComponent implements OnInit {
  @Input() data: ProgressBar[];

  ngOnInit(): void {
    const [data] = checkInputsForText([this.data]);

    this.data = data;
  }
}
